export default __webpack_public_path__ + "static/pink_arrow_mobile-555526aa9e731e518bb046f8e3115428.svg";